import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';



import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-notifications/lib/notifications.css';

import './css/bootstrapnubox.css';
import './css/sitecss.css';

// browser router
import {BrowserRouter} from 'react-router-dom';


//---- uso de CONTEXT API 
import StoreProvider from './store/StoreProvider'; 

ReactDOM.render(
  <StoreProvider >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StoreProvider>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
